import { FormControlLabel } from "@mui/material";
import { CustomSwitch } from "@components/CustomSwitch";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export const SwitchToggle = ({ checked, onChange, label, disabled }: Props) => {
  const control = (
    <CustomSwitch checked={checked} onChange={(e) => onChange(e.target.checked)} disabled={disabled} />
  );
  return label ? <FormControlLabel control={control} label={label} /> : control;
};
